import React, { useState, useEffect, useContext } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
// you will need the css that comes with bootstrap@3. if you are using
// a tool like webpack, you can do the following:
// import "bootstrap/dist/css/bootstrap.css";
// you will also need the css that comes with bootstrap-daterangepicker
import 'bootstrap-daterangepicker/daterangepicker.css';
import styled from 'styled-components';
import { get } from '../utils/get';
import moment from 'moment';
import { FieldProps } from 'formik';
import { TitleText } from './Text';
import { DateFilterSubject } from '../subjects/DateFilterSubject';
import { DateContext } from '../context/DateFilterContext';

const CustomInput = ({
  placeholder,
  backgroundColor,
  value,
  ...props
}: any) => {
  return (
    <InputContainer>
      <DatePickerInput
        backgroundColor={backgroundColor}
        value={value}
        placeholder={placeholder}
        {...props}
      />
    </InputContainer>
  );
};

const DateRangePicker3 = ({
  label,
  backgroundColor,
  field: { value, name },
  form: { setFieldValue }
}: { label?: string; backgroundColor?: string } & FieldProps) => {
  const currentYear = moment().year();
  
  const [ranges, setRanges] = useState({
    'YTD ': [moment().startOf('year'), moment()],
    'Month ': [moment().startOf('month'), moment().endOf('month')],
    'Quarter ': [moment().startOf('quarter'), moment().endOf('quarter')],
    prvYear: [
      moment().year(currentYear - 1).startOf('year'),
      moment().year(currentYear - 1).endOf('year')
    ]
  });

  const [dateFilterState, setDateFilterState] = useContext(DateContext);

  const [active, setActive] = useState('');
  const handleEvent = (event, picker) => {
    setFieldValue(name, {
      startDate: picker.startDate,
      endDate: picker.endDate
    });
  };

  const handleFilters = type => {
    setActive(type);
    switch (true) {
      case 'YTD' === type:
        setFieldValue(name, {
          startDate: moment().startOf('year'),
          endDate: moment()
        });
        setDateFilterState({
          startDate: moment().startOf('year'),
          endDate: moment()
        });
        break;
      case 'month' === type:
        setFieldValue(name, {
          startDate: moment().startOf('month'),
          endDate: moment().endOf('month')
        });
        setDateFilterState({
          startDate: moment().startOf('month'),
          endDate: moment().endOf('month')
        });
        break;
      case 'quarter' === type:
        setFieldValue(name, {
          startDate: moment().startOf('quarter'),
          endDate: moment().endOf('quarter')
        });
        setDateFilterState({
          startDate: moment().startOf('quarter'),
          endDate: moment().endOf('quarter')
        });

        break;
      case 'prvYear' === type:
        setFieldValue(name, {
          startDate: moment().subtract(1, 'year').startOf('year'),
          endDate: moment().subtract(1, 'year').endOf('year')
        });
        setDateFilterState({
          startDate: moment().subtract(1, 'year').startOf('year'),
          endDate: moment().subtract(1, 'year').endOf('year')
        });

        break;
        case 'thisYear' === type:
          setFieldValue(name, {
            startDate: moment().subtract(0, 'year').startOf('year'),
            endDate: moment().subtract(0, 'year').endOf('year')
          });
          setDateFilterState({
            startDate: moment().subtract(0, 'year').startOf('year'),
            endDate: moment().subtract(0, 'year').endOf('year')
          });
  
          break;
      default:
        return;
    }
  };

  useEffect(() => {
    if (dateFilterState.startDate) {
      setFieldValue(name, dateFilterState);
    } else {
      handleFilters('YTD');
    }
    return () => {};
  }, []);

  return (
    <Container isLabelled={!!label}>
      {label && <DateLabel>{label}</DateLabel>}
      <DatesContainer>
        <DateRangePicker
          autoUpdateInput={false}
          startDate={get(value, 'startDate')}
          endDate={get(value, 'endDate')}
          applyButtonClasses='btn-primary'
          onApply={() => setActive('')}
          onEvent={handleEvent}
          ranges={ranges}
        >
          <DateRangeContainer>
            <CustomInput
              backgroundColor={backgroundColor}
              value={
                get(value, 'startDate')
                  ? moment(get(value, 'startDate', '')).format('DD MMMM YYYY')
                  : ''
              }
            />
            <Devider>-</Devider>
            <CustomInput
              backgroundColor={backgroundColor}
              value={
                get(value, 'endDate')
                  ? moment(get(value, 'endDate')).format('DD MMMM YYYY')
                  : ''
              }
            />
          </DateRangeContainer>
        </DateRangePicker>
        <TitleText
          style={active === 'YTD' ? { borderBottom: '2px solid #01A8CE' } : {}}
          onClick={() => {
            handleFilters('YTD');
            setActive('YTD');
          }}
        >
          YTD
        </TitleText>
        <TitleText
          style={
            active === 'month' ? { borderBottom: '2px solid #01A8CE' } : {}
          }
          onClick={() => {
            handleFilters('month');
            setActive('month');
          }}
        >
          Month
        </TitleText>
        <TitleText
          style={
            active === 'quarter' ? { borderBottom: '2px solid #01A8CE' } : {}
          }
          onClick={() => {
            handleFilters('quarter');
            setActive('quarter');
          }}
        >
          Quarter
        </TitleText>
        <TitleText
          style={
            active === 'prvYear' ? { borderBottom: '2px solid #01A8CE' } : {}
          }
          onClick={() => {
            handleFilters('prvYear');
            setActive('prvYear');
          }}
        >
          Last-Year
        </TitleText>
      </DatesContainer>
    </Container>
    //@ts-ignore
  );
};

export default React.memo(DateRangePicker3);

const Container = styled.div<{ isLabelled: boolean }>`
  display: grid;
  grid-template-rows: ${props => props.isLabelled && '1em auto'};
`;

const DateRangeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const DatesContainer = styled.div`
  display: flex;
  ${TitleText} {
    font-size: 12px !important;
    padding: 0em 1em !important;
    color: #01a8ce !important;
    cursor: pointer;
    height: 2.65em;

    &:focus {
      border-bottom: 2px solid #01a8ce;
    }
  }
`;

const InputContainer = styled.div`
  position: relative;
`;

const DatePickerInput = styled.input<{ backgroundColor: string }>`
  padding: 0.5em 1em;
  padding-left: 2em;
  margin: 0.5em 1em;
  font-weight: normal;
  font-size: 12px;
  background-color: ${props => props.backgroundColor || '#fff'};
  font-weight: bold;
  color: #214160;
  box-shadow: none;
  border: none;
  width: 9em;
  border-bottom: 1px solid rgba(33, 65, 96, 0.6);
  display: flex;
  align-items: center;
  &:focus {
    border: none;
    border-bottom: 2px solid rgba(33, 65, 96, 0.6);
    outline: none;
  }

  ::placeholder {
    color: #999;
    font-size: 0.9rem;
  }
`;

const Devider = styled.span`
  text-align: center;
  align-self: center;
  font-weight: 500;
`;

const DateLabel = styled.label`
  color: rgba(33, 65, 96, 0.4);
  font-size: 0.75em;
`;
